import { Headers, Http, BaseRequestOptions,RequestOptionsArgs,RequestOptions,RequestMethod} from '@angular/http';
import {AppSettings} from '../models/AppSettings';
import { Injectable } from '@angular/core';
@Injectable()
export class DefaultRequestOptions extends BaseRequestOptions {
 merge(options?: RequestOptionsArgs): RequestOptions {
     var newOptions = super.merge(options);
     if(localStorage.getItem('auth_token')!=undefined){
        newOptions.headers.set('access_token', localStorage.getItem('auth_token'));
     }
     if (localStorage.getItem('lingua')){
        newOptions.headers.set('lang', localStorage.getItem('lingua'));
     }
    return newOptions;
  }
}


// WEBPACK FOOTER //
// ./src/app/service/CustomRequest.ts